import Vue from 'vue';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

Vue.filter('getTime', val => {
    if (val) {
        return dayjs(String(val)).format('h:mm a');
    }
});

Vue.filter('formatTime', val => {
    let date = val.toDate();
    if (val) {
        return dayjs(date).format('LTS'); //MM/DD
    }
});

Vue.filter('getDay', val => {
    return dayjs(val).format('DD/MM/YYYY');
});

export const notify = () => {
    if (!('Notification' in window)) {
        alert('This browser does not support push notifications!');
    } else if (Notification.permission === 'granted') {
        // Let's check whether notification permissions have already been granted
        // If it's okay let's create a notification
        return;
    } else if (Notification.permission !== 'denied') {
        // Otherwise, we need to ask the user for permission
        Notification.requestPermission(permission => {
            // If the user accepts, let's create a notification
            if (permission === 'granted') {
                return;
            }
        });
    }
};